import { render } from "./patient-setting.vue?vue&type=template&id=075e23f3"
import script from "./patient-setting.vue?vue&type=script&lang=js"
export * from "./patient-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__